import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../static/styles/Layouts.module.css';
import logoImg from '../static/img/eslLogo.png';

import homeIcon from '../static/img/Sidebar/iconHome.svg'
import dailyTaskIcon from '../static/img/Sidebar/iconDailyTasks.svg'
import tournamentIcon from '../static/img/Sidebar/iconTournaments.png'
import rewardsIcon from '../static/img/Sidebar/iconRewards.svg'
import leaderboardIcon from '../static/img/Sidebar/iconLeaderboard.svg'
import highlightsIcon from '../static/img/Sidebar/iconHighlights.svg'
import completedIcon from '../static/img/Sidebar/iconCompletedTasks.svg'
import settingsIcon from '../static/img/Sidebar/iconSettings.svg'
import coinsIcon from '../static/img/Sidebar/iconCheckinCoins.png'
import defaultAvatarIcon from '../static/img/Sidebar/Avatar.png'
import roundedArrowIcon from '../static/img/Sidebar/iconRoundedArrowRight.svg'
import notificationIcon from '../static/img/MobileAppbar/notificationIcon.svg'

import instagramIcon from '../static/img/social/instagram.svg'
import facebookIcon from '../static/img/social/facebook.svg'
import youtubeIcon from '../static/img/social/youtube.svg'
import twitterIcon from '../static/img/social/twitter.svg'

import DailyCheckin from '../views/DailyCheckin';
import { getUserProfile, getUserNotifCount } from '../api/profile';
import { isAuthenticated } from '../api/auth';

function LayoutMobile({ children, profileData }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [value, setValue] = useState(location.pathname);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCheckinOpen, setIsCheckinOpen] = useState(false);
    const [rewardClaimed, setRewardClaimed] = useState(false);
    const [userProfile, setUserProfile] = useState({});
    const [unreadNotifications, setUnreadNotifications] = useState(0);

    useEffect(() => {
        setValue(location.pathname);
        setRewardClaimed(localStorage.getItem('rewardClaimed'));
    }, [location.pathname]);

    useEffect(() => {
        const fetchUserProfile = async () => {
            const profile = await getUserProfile();
            if (profile.success) {
                setUserProfile(profile);
                const name = profile?.name || profile?.username;
                if (name) localStorage.setItem('username', name);
            }
        };
        fetchUserProfile();
    }, []);

    useEffect(() => {
        const fetchNotificationCount = async () => {
            const result = await getUserNotifCount();
            if (result.success && result.notificationsCount !== undefined) {
                setUnreadNotifications(result.notificationsCount);
            }
        };
        fetchNotificationCount();

        const handleRefreshNotifications = () => {
            fetchNotificationCount();
        };
        window.addEventListener('notificationsRead', handleRefreshNotifications);

        return () => {
            window.removeEventListener('notificationsRead', handleRefreshNotifications);
        };
    }, []);

    const handleNavigation = (action) => {
        if (typeof action === 'function') {
            action();
        } else if (typeof action === 'string') {
            navigate(action);
        }
        setIsSidebarOpen(false);
    };

    const menuItems = [
        { icon: homeIcon, label: "Homepage", action: '/' },
        { icon: dailyTaskIcon, label: "Daily tasks", action: '/tasks' },
        { icon: tournamentIcon, label: "Tournaments", action: '/tournaments' },
        { icon: dailyTaskIcon, label: "Gaming Tasks", action: '/daily-gaming-tasks' },
        { icon: rewardsIcon, label: "Rewards", action: '/rewards' },
        { icon: leaderboardIcon, label: "Leaderboard", action: '/leaderboard' },
        { icon: highlightsIcon, label: "Highlights", action: '/highlights' },
        { icon: completedIcon, label: "Completed tasks", action: '/completed' },
        { icon: notificationIcon, label: "Notifications", action: '/notifications', badge: true },
        // { icon: settingsIcon, label: "Settings", action: '/settings' },
    ];

    const socialLinks = [
        { icon: instagramIcon, url: '#', label: 'Instagram' },
        { icon: facebookIcon, url: '#', label: 'Facebook' },
        { icon: youtubeIcon, url: '#', label: 'YouTube' },
        { icon: twitterIcon, url: '#', label: 'Twitter' },
    ];

    const avatarUrl = userProfile?.profileImage || defaultAvatarIcon;
    let username = userProfile?.name || userProfile?.username || "Guest User";
    if (username.length > 7) {
        username = `${username.substring(0, 7)}...`;
    }

    const handleCheckIn = () => {
        if(isAuthenticated()) {
            setIsCheckinOpen(true);
        }
    }

    return (
        <div className={styles.layout}>
            <header className={styles.mobileHeader}>
                <img
                    src={logoImg}
                    alt="ESL"
                    className={styles.mobileLogo}
                    onClick={() => { navigate('/'); window.location.reload(); }}
                />
                <div className={styles.headerActions}>
                    <button
                        onClick={() => navigate('/notifications')}
                        className={styles.notificationButton}
                    >
                        <img src={notificationIcon} alt="Notifications" className={styles.notificationIcon} />
                        {unreadNotifications > 0 && (
                            <span className={styles.notificationBadge}>{unreadNotifications}</span>
                        )}
                    </button>
                    <button
                        onClick={() => setIsSidebarOpen(true)}
                        className={styles.menuButton}
                    >
                        ☰
                    </button>
                </div>
            </header>

            <main className={`${styles.mainContent} ${isSidebarOpen ? styles.blurred : ''}`}>
                <div className={`${styles.mainContentInner} ${location.pathname !== '/' ? styles.mainContentWithHeader : ''}`}>
                    {children}
                    {(location.pathname !== '/puzzle-mania' && location.pathname !== '/space-football') && (
                        <footer className={styles.footer}>
                            <div className={styles.footerLeft}>
                                <p className={styles.footerText}>
                                    Unleash your e-sports potential with Ufone ESG
                                    <br />
                                    © 2026 All Rights Reserved
                                </p>
                                <img src={logoImg} alt="ESG" className={styles.footerLogo} />
                            </div>
                            <div className={styles.footerRight}>
                                <p className={styles.followUsText}>Follow Us</p>
                                <div className={styles.socialIcons}>
                                    {socialLinks.map((social) => (
                                        <a
                                            key={social.label}
                                            href={social.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={social.icon}
                                                alt={social.label}
                                                className={styles.socialIcon}
                                            />
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </footer>
                    )}
                </div>
            </main>

            {/* Drawer Overlay */}
            <div
                className={`${styles.drawerOverlay} ${isSidebarOpen ? styles.drawerOverlayVisible : ''}`}
                onClick={() => setIsSidebarOpen(false)}
            />

            {/* Drawer */}
            <nav className={`${styles.mobileDrawer} ${isSidebarOpen ? styles.mobileDrawerOpen : ''}`}>
                {/* Profile Section */}
                <div className={styles.profileSection} onClick={() => handleNavigation('/profile')}>
                    <img src={avatarUrl} alt="" className={styles.profileImage} 
                    onError={e => { e.target.onerror = null; e.target.src = defaultAvatarIcon; }} />
                    <div className={styles.profileInfo}>
                        <span className={styles.userName}>{username}</span>
                        <span className={styles.profileLabel}>Profile</span>
                    </div>
                    <button onClick={() => setIsSidebarOpen(false)} className={styles.closeButton}>
                        <img src={roundedArrowIcon} alt="Close" />
                    </button>
                </div>

                {/* Menu Items */}
                <ul className={styles.menuList}>
                    {menuItems.map((item, index) => (
                        <li key={item.label}>
                            <button
                                onClick={() => handleNavigation(item.action)}
                                className={`${styles.navItem} ${
                                    item.action === '/tournaments' 
                                        ? (location.pathname === '/tournaments' || location.pathname.startsWith('/tournament/')) ? styles.navItemActive : ''
                                        : location.pathname === item.action ? styles.navItemActive : ''
                                } ${item.highlighted ? styles.highlighted : ''}`}
                            >
                                <div className={styles.navItemContent}>
                                    <img src={item.icon} alt="" className={styles.navIcon} />
                                    <span className={styles.navText}>{item.label}</span>
                                    {item.badge && unreadNotifications > 0 && (
                                        <span className={styles.notificationBadge}>{unreadNotifications}</span>
                                    )}
                                </div>
                            </button>
                        </li>
                    ))}
                </ul>

                <div className={styles.rewardsContainer} onClick={() => { handleCheckIn() }} >
                    <img src={coinsIcon} alt="" className={styles.goldPile} />
                    <button className={styles.checkInButton}>
                        Check in Rewards
                        {/* <span className={styles.notificationBadge}>2</span> */}
                    </button>
                </div>

                <div className={styles.drawerFooter}>
                    <img src={logoImg} alt="ESG" className={styles.drawerLogo} />
                </div>
            </nav>

            <DailyCheckin isOpen={isCheckinOpen} onClose={() => setIsCheckinOpen(false)} />
        </div>
    );
}

export default LayoutMobile;